var _style, _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#4757A9;}\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED5565;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 40.5,
    cy: 40,
    rx: 40.5,
    ry: 40
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-9.7,0H89c6.1,0,11,4.9,11,10.9v58.2c0,6-4.9,10.9-11,10.9H-9.7c-6.1,0-11-4.9-11-10.9V10.9 C-20.7,4.9-15.8,0-9.7,0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-21.6,84.6 -26.3,77.5 102.6,-4.6 107.3,2.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-22.4,83.4 -25.5,78.7 103.4,-3.4 106.5,1.3  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.2,85.1 106.9,78 -21.2,-3.4 -25.9,3.7  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "103,83.9 106.1,79.2 -22,-2.2 -25.1,2.5  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -20.7,
    y: 30.6,
    className: "st1",
    width: 120.6,
    height: 20.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    className: "st1",
    width: 20.7,
    height: 80
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -20.7,
    y: 34,
    className: "st2",
    width: 120.6,
    height: 13.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    className: "st2",
    width: 13.8,
    height: 80
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.17fccbe071aba8e333fe3df7acc94fd6.svg";
export { ForwardRef as ReactComponent };